import script from "./ViewCalendarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewCalendarView.vue?vue&type=script&setup=true&lang=ts"

import "./ViewCalendarView.vue?vue&type=style&index=0&id=ccaf7d44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccaf7d44"]])

export default __exports__